import styled from "styled-components";

export const PayrollDetailsViewContainer = styled.div`
  background: ${({theme}) => theme.white};
  border: 1px solid ${({theme}) => theme.grayDivider};
  border-radius: 8px;
  padding: 32px 0 32px 0;
  h1{
    padding: 0 32px 0 32px;
    font-size: 19px;
    font-weight: 700;
    line-height: 23px;
    letter-spacing: 0.4px;
    text-align: left;
    color: ${({theme}) => theme.black}
  }
  p {
    padding: 0 32px 0 32px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
    letter-spacing: 0.3px;
    color: ${({theme}) => theme.grayLight};
    margin-bottom: 32px;
  }
  
  h3{
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.3px;
    color: ${({theme}) => theme.gray};
    margin-bottom: 32px;
  }
  section{
    padding: 32px;
    border-bottom: 1px solid ${({theme}) => theme.grayDivider};
    
    p {
      padding: 0;
      margin-top: -32px;
    }
  }
  section:last-child {
    padding: 32px 32px 0 32px;
    border-bottom: unset;
    margin-bottom: 0;
  }
`
export const DocumentDownloadArea = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .label {
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: center;
      h3{
        padding: 0;
        margin: 0;
      }
      p {
        padding: 0;
        margin: 0;
      }
    }
    .action{
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
    flex-direction: column;
    .label{
      width: 100%;
    }
    .action {
      width: 100%;
      button {
        width: 100%;
        margin-top: 10px;
      }
    }
  }
`
